import type { ResolvedOpCostsInput } from '@lib/calculations/part-history';
import type { OriginalSource, Part } from '@prisma/client';
import type { QuoteLineFullDTO } from '@prisma-types';
import Decimal from 'decimal.js';

export const QUOTE_LINE_DESCRIPTION_MAX_LENGTH = 120;

// NOTE: This is the Quote version of the SNAP Type defined at
// @api/actions/view-snap-quote/types.ts
type OrderedQuoteLine = {
  createdAt: Date;
  invoicedQuantity: Decimal | null;
  orderId: string;
  orderQuantity: Decimal;
  partId?: string;
  quoteLineNumber: number | null;
  unitPrice: Decimal;
};

export interface QuoteLineWithOrderedLine extends QuoteLineFullDTO {
  orderedLine?: OrderedQuoteLine | null;
}

export interface QuoteLineFull extends QuoteLineWithOrderedLine {
  operationCosts: ResolvedOpCostsInput[] | null;
}

export type QuotePrice = {
  quantity: number;
  unitPrice: number;
};

/**
 * The data we parse from a spreadsheet file is roughly the data required
 * to create a quote line item, but without the `quoteId` and
 * `quoteOriginalSource` (which the spreadsheet and importer won't know, but
 * the calling API or UI code will).
 */
export type ParsedQuoteLine = {
  lineNumber: number;
  partId: string;
  description: string | null;
  customerPartId: string | null;
  finishedPartId: string;
  partOriginalSource: OriginalSource;
  leadTime: number | null;
  leadTimeNotes: string | null;
  note: string | null;
  quotePrices: QuotePrice[];
  isDuplicateQuoteLine?: boolean;
};

export type ImportedQuoteLine = ParsedQuoteLine & {
  part: Part;
};

// @TODO(shawk) @QBV1: delete this when we no longer need to support QBV1
export type ImportedQuoteLineV1 = Omit<ParsedQuoteLine, 'quotePrices'> & {
  part: Part;
  quantity: number;
  unitPrice: number;
  quantityBreaks: Array<QuotePrice & { breakNumber: number }>;
};
